import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationService } from '@app/core/auth';
import { PUBLIC_API_PATHS } from '../../const';

let isSessionExpired = false;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const snackBar = inject(MatSnackBar);
  const expireSession = () => {
    if (isSessionExpired) {
      return;
    }
    isSessionExpired = true;
    authService.logout().subscribe();
    snackBar.open('Tu sesión ha expirado', 'Ok', {
      duration: 5000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['snack-bar-warning']
    });
    setTimeout(() => {
      isSessionExpired = false;
    }, 1000);
  };

  const extractErrorMessage = (err: HttpErrorResponse): string => {
    if (typeof err.error === 'string') return err.error;
    if (err.error?.message) return err.error.message;
    if (err.error?.error) return err.error.error;
    return err.statusText || 'Error en la petición';
  };

  const isPublic = PUBLIC_API_PATHS.some(url => req.url.includes(url));
  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (!isPublic && (err.status === 401 || err.status === 302)) {
        expireSession();
        return EMPTY;
      }

      if (err.status === 403) {
        snackBar.open('No tienes permiso para acceder a este recurso', 'Ok', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['snack-bar-warning']
        });
      }

      return throwError(() => extractErrorMessage(err));
    })
  );
};
